import { faWindowClose } from '@fortawesome/pro-light-svg-icons/faWindowClose';
import React from 'react';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const Waived = ({
  copy,
  dataLinkId,
  isActive,
  setActive,
}: {
  copy: string;
  dataLinkId: string;
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  const iconContainerWaived = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`;
  const waivedLink: string = `${styles.LinkRight}  ${styles.Waived} ${
    isActive ? styles.Active : ''
  }`;

  const waivedIconClass = `${styles.Icon} ${styles.Waived} ${
    isActive ? styles.Active : ''
  }`;

  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faWindowClose}
      iconClassName={waivedIconClass}
      iconContainerClassName={iconContainerWaived}
      textClassName={waivedLink}
      copy={copy}
      onClick={onClick}
    />
  );
};

export default Waived;
